<template>
    <b-card>
        <h2><strong>Laba Rugi</strong></h2>
        <b-row class="justify-content-center">
        <b-col cols="12" class="d-flex align-items-center justify-content-center">
            <b-form-group label="Dari" class="mr-1">
            <b-form-input v-model="filter.tgl_awal" type="date"></b-form-input>
            </b-form-group>
            <b-form-group label="Sampai" class="mr-1">
            <b-form-input v-model="filter.tgl_akhir" type="date"></b-form-input>
            </b-form-group>
            <b-form-group label="-">
            <b-button variant="primary" @click.prevent="getGraphicData"><feather-icon icon="FilterIcon" class="mr-1" />Filter</b-button>
            </b-form-group>
        </b-col>
        </b-row>
        <app-echart-bar :optionData="profitAndLoss" />
    </b-card>
</template>
<script>
import AppEchartBar from "@core/components/charts/echart/AppEchartBar.vue"
import {BCard, BRow, BCol, BFormGroup, BFormInput, BButton} from 'bootstrap-vue'
export default {
    components: {
        BCard, BRow, BCol, BFormGroup, BFormInput, BButton, AppEchartBar
    },
    data: () => ({
        filter: {
            tgl_awal: '2022-11-01',
            tgl_akhir: '2022-11-20'
        },
        profitAndLoss: {
            xAxis: {
                data: []
            },
            yAxis: {
                type: 'value'
            },
            series: [
                {
                    type: 'bar',
                    data: []
                }
            ]
        }
    }),
    methods: {
        async getGraphicData() {
            const params = {}
            if(this.filter.tgl_awal) params.tgl_awal = this.filter.tgl_awal
            if(this.filter.tgl_akhir) params.tgl_akhir = this.filter.tgl_akhir

            try {
                const profitAndLoss = await this.$store.dispatch('dashboard/getGrafikLabaRugi', params)
                const dataPendapatan = {
                    value: profitAndLoss.data[0],
                    itemStyle: {
                        color: '#00cfe8'
                    }
                }
                const dataPengeluaran = {
                    value: profitAndLoss.data[1],
                    itemStyle: {
                        color: '#ff9f43'
                    }
                }
                const dataLabaRugi = {
                    value: profitAndLoss.data[2],
                    itemStyle: {
                        color: '#4cef47'
                    }
                }
                
                this.profitAndLoss.xAxis.data = profitAndLoss.label
                this.profitAndLoss.series[0].data = [dataPendapatan, dataPengeluaran, dataLabaRugi]
            }
            catch(e) {
                this.displayError(e)
                return false
            }
        },
        getLast7Days() {
            let result = []
            const num = 7
            for(let i = 0; i <= num; i++) {
                const currentDate = new Date()
                const ii = i == 0 ? currentDate.getDate() : currentDate.getDate() - i
                currentDate.setDate( ii )
                result.push(currentDate)
            }
            result = result.reverse()
            const tgl_awal = result[0]
            const tgl_akhir = result[result.length - 1]
            const awalMonth = tgl_awal.getMonth() + 1 < 10 ? `0${tgl_awal.getMonth() + 1}` : tgl_awal.getMonth()
            const akhirMonth = tgl_akhir.getMonth() + 1 < 10 ? `0${tgl_akhir.getMonth() + 1}` : tgl_akhir.getMonth()
            const awalDate = tgl_awal.getDate() < 10 ? `0${tgl_awal.getDate()}` : tgl_awal.getDate()
            const akhirDate = tgl_akhir.getDate() < 10 ? `0${tgl_akhir.getDate()}` : tgl_akhir.getDate()
            this.filter.tgl_awal = `${tgl_awal.getFullYear()}-${awalMonth}-${awalDate}`
            this.filter.tgl_akhir = `${tgl_akhir.getFullYear()}-${akhirMonth}-${akhirDate}`
        }
    },
    async created() {
        await this.getLast7Days()
        this.getGraphicData()
    }
}
</script>